export class AreaInformation {
	public sRange: string;
	public left: number;
	public right: number;
	public hasPortrait: boolean;
}